<template>
  <span class="danger ml-2">{{ requiredMessage }}</span>
</template>

<script>
import {getMessage} from "@/common/message-service";

export default {
  name: "RequiredField",
  computed: {
    requiredMessage () {
      return getMessage('REQUIRED.FIELD');
    }
  }
}
</script>


